export default __webpack_public_path__ + "static/media/ytili-young-transatlantic-innovation-leaders-initiative-fellowship-program.0bd36423.png";